module.exports = __webpack_public_path__ + "static/media/overpass-thin-italic.849bc426.woff";